/* eslint-disable eqeqeq */
import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/styles";
import NavBar from "../../../components/NavBar/NavBar";
import OrderTabV2 from "./Chunks/OrderTabV2";
import SalesTabV3 from "./Chunks/SalesTabV3";
import ImagesTabV2 from "./Chunks/ImagesTabV2";
import ChangeStatusV2 from "./Chunks/ChangeStatusV2";
import EditTrayV2 from "./Chunks/EditTrayV2";
import ImageViewDialogV2 from "./Chunks/ImageViewDialogV2";
import { IsEmpty, clearAllCache } from "../../../utils/helper";
import { Button } from "@material-ui/core";
import {
  HttpRequest,
  HttpRequestFileDownload,
} from "../../../utils/httpRequests";
import LoginMenu from "../../../components/LoginMenu/LoginMenu";
import CustomizedSnackbar from "../../../components/CustomizedSnackbar/CustomizedSnackbar";

const useStyles = (theme) => ({
  icon: {
    marginRight: theme.spacing(1),
  },
  heroContent: {
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(2, 0, 2),
  },
  heroButtons: {
    marginTop: theme.spacing(4),
  },
  cardGrid: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  card: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
  },
  cardMedia: {
    paddingTop: "56.25%", // 16:9
  },
  cardContent: {
    flexGrow: 1,
  },
  cardContentDiv: {
    display: "flex",
    justifyContent: "space-between",
  },
  footer: {
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(6),
  },
  tabsContainer: {
    // width: "30%",
    // display: "flex",
    float: "left",
    // justifyContent: "space-between",
    // overFlow: "hidden",
    marginLeft: 10,
    marginRight: 10,
    boxShadow:
      "0 4px 4px 0 rgba(0, 0, 0, 0.2), 0 2px 15px 0 rgba(0, 0, 0, 0.19)",
  },
  tabsContentContainer: {
    width: "98%",
    // display: "flex",
    justifyContent: "space-between",
    // boxShadow:
    // "0 4px 4px 0 rgba(0, 0, 0, 0.2), 0 2px 15px 0 rgba(0, 0, 0, 0.19)",

    overFlow: "auto",
  },
  tabsContentContainerImages: {
    width: "100%",
    // display: "flex",
    justifyContent: "space-between",

    // overFlow: "auto",
  },
  // tabsContentContainerDetail: {
  //   width: "75%",
  //  // display: "flex",
  //   justifyContent: "space-between",
  //   marginTop: 62,
  //   overFlow: "auto",
  // },
  contentContainerImages: {
    alignItems: "center",
    textAlign: "center",
    width: "98%",
    marginLeft: 5,
    marginRight: 5,
  },
  contentContainerSM: {
    float: "left",
    alignItems: "center",
    textAlign: "center",
    width: "100%",
    marginLeft: 10,
    marginRight: 5,
    backgroundColor: "red",
  },
  contentItemsContainerSM: {
    alignItems: "center",
    textAlign: "center",
    width: "100%",
    marginLeft: 10,
    marginRight: 5,
    marginTop: 4,
  },
  activeButton: {
    // Active button styles
    backgroundColor: "#3F51B5",
    borderColor: "#596dde",
    color: "#fff",
    "&:hover": {
      backgroundColor: "#3F51B5",
      borderColor: "#596dde",
      boxShadow: "none",
    },
  },
});

const BootstrapButton = withStyles({
  root: {
    //boxShadow: '',
    color: "black",
    textTransform: "none",
    fontSize: 16,
    padding: "6px 12px",
    border: "1px solid",
    outline: "none", // added this
    lineHeight: 1.5,
    width: 180,
    height: 33,
    margin: 10,
    backgroundColor: "#FFFFFF",
    borderColor: "#fff",
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
    "&:hover": {
      backgroundColor: "#3F51B5",

      boxShadow: "none",
      outline: "none", // added this
    },
    "&:active": {
      backgroundColor: "#3F51B5 !important",

      color: "#ffff",
      boxShadow: "none",
      outline: "none", // added this
    },
    "&:focus": {
      // boxShadow: '0 0 0 0.2rem rgba(0,123,255,.5)',
      backgroundColor: "#3F51B5 !important",

      color: "#ffff",
      outline: "none", // added this
    },
  },
})(Button);

class C08SublimationPrintingDashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ordersData: [],
      ordersDataLoading: false,
      salesData: [],
      salesDataLoading: false,
      imagesData: [],
      imagesDataLoading: false,
      barcodeData: [],
      barcodeDataLoading: false,
      selectedOrder: {},
      selectedSalesData: {},

      isDownloadImages: false,
      isDownloadPdfImages: false,

      isLoading: false,
      isReload: true,

      boqData: [],

      listOfActivitiesData: [
        { id: 1, label: "Send for Printing" },
        { id: 2, label: "Issue Materials" },
        { id: 3, label: "Arrange Cardboard" },
        { id: 4, label: "Print Barcode" },
        { id: 5, label: "Assign Barcode toa bin" },
      ],

      openChangeStatusDialog: false,
      selectionData: [],
      selectionDataError: "",

      statusData: [],
      statusDataLoading: false,

      status: "",
      statusError: "",

      remarks: "",
      remarksError: "",

      filterStatus: 1,
      filterStatusError: "",

      selectImageObject: {},
      selectImageIndex: 0,
      isOpenImageViewer: false,

      isNextArrowDisabled: true,
      isBackArrowDisabled: true,

      isOpenSnackbar: false,
      snackbarMessage: "",
      snackbarSeverity: "",

      onConfirmItemStatusLoading: false,
      onCancelItemStatusLoading: false,
      traybarCode: "",
      traybarCodeDisabled: true,
      onScanTrayBarCodeLoading: false,
      sendToQALoading: false,

      selectionTabStatus: [
        { name: "PENDING", value: 1 },
        { name: "DOWNLOADED", value: 2 },
      ],
      rows: [],
      columns: [
        { name: "name", title: "Name" },
        { name: "traybarcode", title: "Tray Barcode" },
        { name: "bundleLabel", title: "Bundles" },
        { name: "copies", title: "Copies" },
        { name: "size", title: "Size" },
        // { name: "paperQuality", title: "Paper Quality" },
        // { name: "lamination", title: "Lamination" },
      ],
      activeButtonIndex: 1,
      openEditTrayDialog: false,
      userEmail: "",
      userPassword: "",
      trayBarCodeWithAuthenication: "",

      isForceCancel: false,
    };
  }

  componentWillUnmount() {
    setTimeout(function () {
      clearAllCache();
    }, 0);
  }

  componentDidMount() {
    this.getData(
      `/sales/C08SalesOrderStatusView`,
      "statusData",
      "statusDataLoading"
    );
    this.setState({
      columns: [
        { name: "name", title: "Name" },
        { name: "traybarcode", title: "Tray Barcode" },
        { name: "bundleLabel", title: "Bundles" },
        { name: "copies", title: "Copies" },
        { name: "size", title: "Size" },
        // { name: "paperQuality", title: "Paper Quality" },
        // { name: "lamination", title: "Lamination" },
      ],
    });

    this.getOrdersData();
  }

  onDonePrintingClick = async () => {
    this.setState({
      onDoneItemStatusLoading: true,
    });

    const orderItemId = IsEmpty(this.state.selectedSalesData)
      ? 0
      : this.state.selectedSalesData.id;

    const data = new FormData();

    data.append("statusId", 4);
    data.append("orderItemId", orderItemId);

    const res = await HttpRequest(
      "POST",
      `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/sales/C08SalesOrderItemsStatusSave`,
      data,
      "authorize"
    );

    if (res.isSuccess) {
      this.handleSnackbar(true, "Updated", "success");
      this.getData(
        `/sales/C08SalesOrderStatusView`,
        "statusData",
        "statusDataLoading"
      );
      this.getOrdersData(this.state.filterStatus);
    } else {
      if (res.statusCode === 401) {
        this.setState({
          isLoginMenu: true,
          isReload: false,
        });
      } else {
        this.handleSnackbar(true, res.message, "error");
      }
    }
    this.setState({
      onDoneItemStatusLoading: false,
    });
  };

  handleSnackbar = (isOpen, message, severity) => {
    this.setState({
      isOpenSnackbar: isOpen,
      snackbarMessage: message,
      snackbarSeverity: severity,
    });
  };

  getData = async (endpoint = "", stateName = "", loadingStateName = "") => {
    let resData = [];
    this.setState({
      [loadingStateName]: true,
    });
    const res = await HttpRequest(
      "GET",
      `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}${endpoint}`,
      null,
      "authorizeJson"
    );
    if (res.isSuccess) {
      resData = res.data || [];
    } else {
      if (res.statusCode === 401) {
        this.setState({
          isLoginMenu: true,
        });
      }
    }

    switch (stateName) {
      case "ordersData":
        this.setState({
          selectedOrder: {},
          imagesData: [],
          selectedSalesData: {},
          salesData: [],
          rows: [],
        });
        break;
      case "salesData":
        if (res.isSuccess && resData.length > 0) {
          const rowsObj = resData || [];

          for (var i = 0; i < rowsObj.length; i++) {
            if (this.state.filterStatus == 2) {
              rowsObj[i].action = (
                <Button
                  onClick={() => this.onDonePrintingClick()}
                  outline
                  style={{
                    //textDecoration: "underline",
                    fontSize: 13,
                    padding: 5,
                    textTransform: "capitalize",
                    // cursor: `${
                    //   this.props.values.isDownloadImages
                    //     ? "waiting"
                    //     : "pointer"
                    // }`,
                  }}
                  color="primary"
                >
                  Done Printing
                </Button>
              );
            }

            rowsObj[i].paperQuality =
              rowsObj[i].paperQuality === "" ? "N/A" : rowsObj[i].paperQuality;
            rowsObj[i].lamination =
              rowsObj[i].lamination === "" ? "N/A" : rowsObj[i].lamination;
          }
          this.setState({
            rows: rowsObj,
          });

          const salesDataObj = resData[0] || {};
          const orderId = !IsEmpty(salesDataObj)
            ? salesDataObj.orderId || 0
            : 0;
          const productId = !IsEmpty(salesDataObj)
            ? salesDataObj.productId || 0
            : 0;
          const jobId = !IsEmpty(this.state.selectedOrder)
            ? this.state.selectedOrder.jobId || 0
            : 0;
          this.getImagesAgainstOrderIdAndProductId(
            salesDataObj,
            orderId,
            productId,
            jobId
          );
        }

        break;
      case "statusData":
        if (res.isSuccess && resData.length > 0) {
          const statusDataObj = resData || {};
          const statusData = !IsEmpty(statusDataObj) ? statusDataObj || [] : [];
          this.setState({
            selectionTabStatus: statusData,
          });
        }
        break;
      case "barcodeData":
        if (res.isSuccess && resData.length > 0) {
          localStorage.setItem("ckBarcodeData", JSON.stringify(resData[0]));
          window.open("#/print-summary");
        }
        break;

      case "traybarcodeData":
        if (res.isSuccess && resData.length > 0) {
          this.getSalesData(this.state.selectedOrder.jobId);
        }
        break;
      // case "isDocumentDownloaded":
      //    if (res.isSuccess && resData.length > 0) {
      //      this.getOrdersData(this.state.filterStatus)
      //    }
      // break;
      default:
        break;
    }

    this.setState({
      [stateName]: resData,
      [loadingStateName]: false,
    });
  };

  getOrdersData = async (status = "") => {
    const statusValue = status !== "" ? status : this.state.filterStatus;
    this.getData(
      `/sales/C08SalesOrderView?isDownloaded=${statusValue}`,
      "ordersData",
      "ordersDataLoading"
    );
  };

  getSalesData = async (jobId) => {
    this.getData(
      `/sales/C08SalesOrderItemsViewV3?jobId=${jobId}&statusId=${this.state.filterStatus}`,
      "salesData",
      "salesDataLoading"
    );
  };

  getImagesData = async (orderId, productId, jobId) => {
    this.getData(
      `/sales/C08SalesOrderItemsImagesViewV2?orderId=${orderId}&productId=${productId}&orderItemId=${jobId}`,
      "imagesData",
      "imagesDataLoading"
    );
  };

  isDocumentPrintDocumentDownloaded = async () => {
    const orderItemId = IsEmpty(this.state.selectedOrder)
      ? 0
      : this.state.selectedOrder.jobId;

    const data = new FormData();
    data.append("jobId", orderItemId);
    const loadingName = "documentDownloadedDataLoading";

    const res = await HttpRequest(
      "POST",
      `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/sales/C08SalesOrderItemsDownloadDocumentStatusSave`,
      data,
      "authorize"
    );

    if (res.isSuccess) {
      this.getData(
        `/sales/C08SalesOrderStatusView`,
        "statusData",
        "statusDataLoading"
      );
      this.getOrdersData(this.state.filterStatus);
      this.handleSnackbar(true, "File Downloaded", "success");
    } else {
      if (res.statusCode === 401) {
        this.setState({
          isLoginMenu: true,
          isReload: false,
        });
      } else {
        this.handleSnackbar(true, res.message, "error");
      }
    }
    this.setState({
      [loadingName]: false,
    });
  };

  // scanTrayBarcode = async () => {
  //   this.getData(
  //     `/sales/C01SalesOrderItemsScanTrayBarCodeView?orderId=${this.state.selectedOrder.orderId}&productId=${this.state.selectedSalesData.productId}`,
  //     "traybarcodeData",
  //     "barcodeDataLoading"
  //   );
  // };

  toggleChangeStatusDialog = (data) => {
    const { openChangeStatusDialog } = this.state;
    this.setState({
      openChangeStatusDialog: !openChangeStatusDialog,
      selectedData: data,
    });
  };

  onCheckClick = (e, row = {}) => {
    const { checked } = e.target;
    let { ordersData } = this.state;
    const studentIndex = ordersData.findIndex(
      (item) => item.orderId === row.orderId
    );
    ordersData[studentIndex].isChecked = checked;
    this.setState({
      ordersData,
      selectionDataError: "",
    });
  };

  getOrderId = (order) => {
    this.getSalesData(order.jobId);
    const { isForceCancel } = this.state;
    this.setState({
      selectedOrder: order,
      imagesData: [],
      selectedSalesData: {},
      isForceCancel: !isForceCancel,
    });
  };

  getImagesAgainstOrderIdAndProductId = (sale, orderId, productId, jobId) => {
    this.getImagesData(orderId, productId, jobId);
    this.setState({
      selectedSalesData: sale,
    });
  };

  onHandleChange = (e) => {
    const { name, value } = e.target;
    let columnsObj = [];
    const errName = `${name}Error`;
    switch (name) {
      case "filterStatus":
        this.getOrdersData(value);

        if (value == 1) {
          columnsObj = [
            { name: "name", title: "Name" },
            { name: "traybarcode", title: "Tray Barcode" },
            { name: "bundleLabel", title: "Bundles" },
            { name: "copies", title: "Copies" },
            { name: "size", title: "Size" },
            // { name: "paperQuality", title: "Paper Quality" },
            // { name: "lamination", title: "Lamination" },
          ];
        } else {
          columnsObj = [
            { name: "name", title: "Name" },
            { name: "traybarcode", title: "Tray Barcode" },
            { name: "bundleLabel", title: "Bundles" },
            { name: "copies", title: "Copies" },
            { name: "size", title: "Size" },
            // { name: "paperQuality", title: "Paper Quality" },
            // { name: "lamination", title: "Lamination" },
            { name: "action", title: "Action" },
          ];
        }
        this.setState({
          salesData: [],
          salesDataLoading: false,
          imagesData: [],
          imagesDataLoading: false,
          selectedOrder: {},
          selectedSalesData: {},
          traybarCodeDisabled: true,
          rows: [],
          columns: columnsObj,
        });

        break;
      default:
        break;
    }
    this.setState({
      [name]: value,
      [errName]: "",
      selectionDataError: "",
    });
  };

  isFormValid = () => {
    let { statusError } = this.state;
    let isValid = true;

    if (!this.state.status) {
      isValid = false;
      statusError = "Please select status";
    } else {
      statusError = "";
    }

    this.setState({
      statusError,
    });

    return isValid;
  };

  onSaveClick = () => {
    if (this.isFormValid()) {
      document.getElementById("btnStatusSubmit").click();
    }
  };

  // onFormSubmit = async (e) => {
  //   e.preventDefault();
  //   this.setState({
  //     isLoading: true,
  //   });
  //   const data = new FormData(e.target);

  //   const res = await HttpRequest(
  //     "POST",
  //     `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/sales/C01SalesOrderSaveStatusV2`,
  //     data,
  //     "authorize"
  //   );

  //   if (res.isSuccess) {
  //     this.handleSnackbar(true, "Saved", "success");
  //     this.setState({
  //       status: "",
  //       statusError: "",
  //       remarks: "",
  //       remarksError: "",
  //     });
  //     this.getData(
  //       `/sales/C01SalesOrderView?statusId=${this.state.filterStatus}`,
  //       "ordersData",
  //       ""
  //     );

  //   } else {
  //     if (res.statusCode === 401) {
  //       this.setState({
  //         isLoginMenu: true,
  //         isReload: false,
  //       });
  //     } else {
  //       this.handleSnackbar(true, res.message, "error");
  //     }
  //   }
  //   this.setState({
  //     isLoading: false,
  //   });
  // };

  onImageClick = (object) => {
    let { imagesData, isNextArrowDisabled, isBackArrowDisabled } = this.state;
    const currentImageIndex = imagesData.findIndex(
      (item) => item.id == object.id
    );

    if (currentImageIndex != -1) {
      if (currentImageIndex == 0) {
        isBackArrowDisabled = true;
      } else {
        isBackArrowDisabled = false;
      }
      if (currentImageIndex + 1 == imagesData.length) {
        isNextArrowDisabled = true;
      } else {
        isNextArrowDisabled = false;
      }
    }

    window.addEventListener(
      "keydown",
      this.handleOnKeyPressedForImageDilog,
      false
    );

    this.setState({
      selectImageObject: object,
      isOpenImageViewer: true,
      selectImageIndex: currentImageIndex,
      isNextArrowDisabled,
      isBackArrowDisabled,
    });
  };

  handleImageViewerToggle = () => {
    const value = this.state.isOpenImageViewer ? false : true;
    this.setState({
      isOpenImageViewer: value,
    });
  };

  downloadFile = async (e, fileName) => {
    e.preventDefault();

    const url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/albums/C01ImageView?fileName=${fileName}`;

    let result = await HttpRequestFileDownload(
      "GET",
      url,
      "authorizeJson",
      fileName
    );

    if (result.isSuccess) {
      let csvURL = URL.createObjectURL(result.data);
      var tempLink = document.createElement("a");
      tempLink.href = csvURL;
      tempLink.setAttribute("download", fileName);
      tempLink.click();
    } else {
      if (result.statusCode === 401) {
        this.setState({
          isLoginMenu: true,
          isReload: false,
        });
      } else {
        alert(result.message);
      }
    }
  };

  downloadImagesData = async () => {
    if (this.state.isDownloadImages === false) {
      this.setState({
        isDownloadImages: true,
      });
      const url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/sales/C08SalesOrderItemsImagesDownloadV2?orderId=${this.state.selectedSalesData.orderId}&productId=${this.state.selectedSalesData.productId}`;
      const fileName = `${this.state.selectedSalesData.orderId}-${this.state.selectedSalesData.name}.zip`;
      let result = await HttpRequestFileDownload(
        "GET",
        url,
        "authorizeJson",
        fileName
      );

      if (result.isSuccess) {
        let csvURL = URL.createObjectURL(result.data);
        var tempLink = document.createElement("a");
        tempLink.href = csvURL;
        tempLink.setAttribute("download", fileName);
        tempLink.click();
        if (this.state.filterStatus == 1) {
          this.isDocumentPrintDocumentDownloaded();
        }
      } else {
        if (result.statusCode === 401) {
          this.setState({
            isLoginMenu: true,
            isReload: false,
          });
        } else {
          alert(result.message);
        }
      }

      this.setState({
        isDownloadImages: false,
      });
    }
  };
  downloadPdfImagesData = async () => {
    if (!this.state.isDownloadPdfImages) {
      this.setState({
        isDownloadPdfImages: true,
      });
      const url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/sales/C08SalesOrderItemsImagesDownloadPdfV2?orderId=${this.state.selectedSalesData.orderId}&productId=${this.state.selectedSalesData.productId}`;
      const fileName = `${this.state.selectedSalesData.orderId}-${this.state.selectedSalesData.name}.zip`;
      let result = await HttpRequestFileDownload(
        "GET",
        url,
        "authorizeJson",
        fileName
      );

      if (result.isSuccess) {
        let csvURL = URL.createObjectURL(result.data);
        var tempLink = document.createElement("a");
        tempLink.href = csvURL;
        tempLink.setAttribute("download", fileName);
        tempLink.click();
        if (this.state.filterStatus == 1) {
          this.isDocumentPrintDocumentDownloaded();
        }
      } else {
        if (result.statusCode === 401) {
          this.setState({
            isLoginMenu: true,
            isReload: false,
          });
        } else {
          alert(result.message);
        }
      }

      this.setState({
        isDownloadPdfImages: false,
      });
    }
  };

  handleChangeStatusClose = () => {
    this.toggleChangeStatusDialog();
    this.setState({
      status: "",
      statusError: "",
      remarks: "",
      remarksError: "",
    });
  };

  onNextArrowClick = () => {
    let {
      imagesData,
      isNextArrowDisabled,
      isBackArrowDisabled,
      selectImageIndex,
      selectImageObject,
    } = this.state;
    let imageObject = selectImageObject;
    let prevImageIndex = selectImageIndex;
    let nextImageIndex = selectImageIndex;

    if (prevImageIndex != -1) {
      nextImageIndex = prevImageIndex + 1;
      if (nextImageIndex == imagesData.length) {
        isNextArrowDisabled = true;
      } else {
        if (nextImageIndex + 1 == imagesData.length) {
          isNextArrowDisabled = true;
        } else {
          isNextArrowDisabled = false;
        }
        isBackArrowDisabled = false;
        imageObject = imagesData[nextImageIndex] || {};
      }
    }

    this.setState({
      selectImageObject: imageObject,
      selectImageIndex: nextImageIndex,
      isNextArrowDisabled,
      isBackArrowDisabled,
    });
  };

  onBackArrowClick = () => {
    let {
      imagesData,
      isNextArrowDisabled,
      isBackArrowDisabled,
      selectImageIndex,
      selectImageObject,
    } = this.state;
    let imageObject = selectImageObject;
    let prevImageIndex = selectImageIndex;
    let newImageIndex = selectImageIndex;

    if (prevImageIndex != -1 || prevImageIndex != 0) {
      newImageIndex = prevImageIndex - 1;

      if (newImageIndex == 0) {
        isBackArrowDisabled = true;
      } else {
        isBackArrowDisabled = false;
      }
      isNextArrowDisabled = false;
      imageObject = imagesData[newImageIndex] || {};
    }

    this.setState({
      selectImageObject: imageObject,
      selectImageIndex: newImageIndex,
      isNextArrowDisabled,
      isBackArrowDisabled,
    });
  };

  handleCloseImageDialog = () => {
    window.removeEventListener("keydown", this.handleOnKeyPressedForImageDilog);
    this.setState({
      isOpenImageViewer: false,
      selectImageIndex: 0,
      selectImageObject: {},
      isBackArrowDisabled: true,
      isNextArrowDisabled: true,
    });
  };

  handleOnKeyPressedForImageDilog = (event) => {
    switch (event.key) {
      case "ArrowRight":
        if (!this.state.isNextArrowDisabled) {
          this.onNextArrowClick();
        }
        break;
      case "ArrowLeft":
        if (!this.state.isBackArrowDisabled) {
          this.onBackArrowClick();
        }
        break;
      default:
        break;
    }
  };

  onImagesConfirmationClick = async (statusId) => {
    const orderItemId = IsEmpty(this.state.selectedSalesData)
      ? 0
      : this.state.selectedSalesData.id;

    const orderId = IsEmpty(this.state.selectedOrder)
      ? 0
      : this.state.selectedOrder.orderId;

    const loadingName =
      statusId == 2
        ? "onConfirmItemStatusLoading"
        : "onCancelItemStatusLoading";

    this.setState({
      [loadingName]: true,
    });
    const data = new FormData();
    data.append("orderItemId", orderItemId);
    data.append("statusId", statusId);
    data.append("remarks", this.state.remarks);

    const res = await HttpRequest(
      "POST",
      `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/sales/C01SalesOrderItemsStatusSaveV2`,
      data,
      "authorize"
    );

    if (res.isSuccess) {
      let resData = [];
      let selectedSalesData = {};
      const endPoint = `/sales/C01SalesOrderItemsViewV2?orderId=${orderId}&statusId=${this.state.filterStatus}`;
      const res2 = await HttpRequest(
        "GET",
        `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}${endPoint}`,
        null,
        "authorizeJson"
      );
      if (res2.isSuccess) {
        resData = res2.data || [];
        if (resData.length > 0) {
          selectedSalesData = resData.find((item) => item.id == orderItemId);
        }
        this.setState({
          salesData: resData,
          selectedSalesData,
        });
      } else {
        if (res2.statusCode === 401) {
          this.setState({
            isLoginMenu: true,
          });
        } else {
          // this.handleSnackbar(true, res2.message, "error");
        }
      }
      this.getData(
        `/sales/C01SalesOrderView?statusId=${this.state.filterStatus}`,
        "ordersData",
        ""
      );
      if (statusId == 3) this.toggleChangeStatusDialog();
      this.setState({
        remarks: "",
        remarksError: "",
      });
      this.handleSnackbar(true, "Updated", "success");
    } else {
      if (res.statusCode === 401) {
        this.setState({
          isLoginMenu: true,
          isReload: false,
        });
      } else {
        this.handleSnackbar(true, res.message, "error");
      }
    }
    this.setState({
      [loadingName]: false,
    });
  };

  onFocusOutTrayBarCodeField = () => {
    if (!IsEmpty(this.state.selectedSalesData)) {
      if (!IsEmpty(this.state.traybarCode)) {
        this.onScanTray();
      }
    }
  };

  sendToQA = async (actionId) => {
    const orderItemId = IsEmpty(this.state.selectedSalesData)
      ? 0
      : this.state.selectedSalesData.id;

    const orderId = IsEmpty(this.state.selectedOrder)
      ? 0
      : this.state.selectedOrder.orderId;

    const data = new FormData();
    data.append("orderItemId", orderItemId);
    data.append("orderId", orderId);
    data.append("statusId", actionId);

    const loadingName = "sendToQALoading";

    const res = await HttpRequest(
      "POST",
      `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/sales/C01SalesOrderItemStatusQAFailedSave`,
      data,
      "authorize"
    );

    if (res.isSuccess) {
      this.getData(
        `/sales/C01SalesOrderView?statusId=${this.state.filterStatus}`,
        "ordersData",
        ""
      );
      this.handleSnackbar(true, "Sent To QA", "success");
    } else {
      if (res.statusCode === 401) {
        this.setState({
          isLoginMenu: true,
          isReload: false,
        });
      } else {
        this.handleSnackbar(true, res.message, "error");
      }
    }
    this.setState({
      [loadingName]: false,
    });
  };

  onScanTray = async () => {
    const orderItemId = IsEmpty(this.state.selectedSalesData)
      ? 0
      : this.state.selectedSalesData.id;

    const orderId = IsEmpty(this.state.selectedOrder)
      ? 0
      : this.state.selectedOrder.orderId;

    const itemAssignedTrayBarCode = IsEmpty(this.state.traybarCode)
      ? ""
      : this.state.traybarCode;

    const data = new FormData();
    data.append("orderItemId", orderItemId);
    data.append("orderId", orderId);
    data.append("trayBarCode", itemAssignedTrayBarCode);
    const loadingName = "onScanTrayBarCodeLoading";

    const res = await HttpRequest(
      "POST",
      `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/sales/C01SalesOrderItemsAssignTrayBarCodeSave`,
      data,
      "authorize"
    );

    if (res.isSuccess) {
      this.setState({
        traybarCode: "",
      });

      this.handleSnackbar(true, "Tray Assigned", "success");
      this.getSalesData(orderItemId);
    } else {
      if (res.statusCode === 401) {
        this.setState({
          isLoginMenu: true,
          isReload: false,
        });
      } else {
        this.handleSnackbar(true, res.message, "error");
      }
    }
    this.setState({
      [loadingName]: false,
    });
  };

  onEditTray = async () => {
    const orderItemId = IsEmpty(this.state.selectedSalesData)
      ? 0
      : this.state.selectedSalesData.id;

    const orderId = IsEmpty(this.state.selectedOrder)
      ? 0
      : this.state.selectedOrder.orderId;

    const itemAssignedTrayBarCode = IsEmpty(
      this.state.trayBarCodeWithAuthenication
    )
      ? ""
      : this.state.trayBarCodeWithAuthenication;

    const userEmail = IsEmpty(this.state.userEmail) ? "" : this.state.userEmail;

    const userPassword = IsEmpty(this.state.userPassword)
      ? ""
      : this.state.userPassword;

    const data = new FormData();
    data.append("orderItemId", orderItemId);
    data.append("orderId", orderId);
    data.append("trayBarCode", itemAssignedTrayBarCode);
    data.append("userEmail", userEmail);
    data.append("userPassword", userPassword);

    const loadingName = "onScanTrayBarCodeLoading";

    const res = await HttpRequest(
      "POST",
      `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/sales/C01SalesOrderItemsAssignTrayBarCodeEdit`,
      data,
      "authorize"
    );

    if (res.isSuccess) {
      const { openEditTrayDialog } = this.state;
      this.setState({
        itemAssignedTrayBarCode: "",
        openEditTrayDialog: !openEditTrayDialog,
        userEmail: "",
        userPassword: "",
      });

      this.handleSnackbar(true, "Tray Changed", "success");
      this.getSalesData(orderItemId);
    } else {
      if (res.statusCode === 401) {
        this.setState({
          isLoginMenu: true,
          isReload: false,
        });
      } else {
        if (res.CODE == 4) {
          this.handleSnackbar(true, res.SYSTEM_MESSAGE, "error");
        } else {
          this.handleSnackbar(true, res.message, "error");
        }
      }
    }
    this.setState({
      [loadingName]: false,
    });
  };

  toggleEditTrayDialog = () => {
    const { openEditTrayDialog } = this.state;
    this.setState({
      openEditTrayDialog: !openEditTrayDialog,
    });
  };
  handleChangeEditTrayClose = () => {
    const { openEditTrayDialog } = this.state;
    this.setState({
      openEditTrayDialog: !openEditTrayDialog,
    });
  };

  render() {
    const salesDataObj = this.state.salesData || [];

    const { classes } = this.props;
    return (
      <Fragment>
        <NavBar isAuthorize title="Sublimation Printing Dashboard" />
        <LoginMenu
          reload={this.state.isReload}
          open={this.state.isLoginMenu}
          handleClose={() => this.setState({ isLoginMenu: false })}
        />
        <form onSubmit={this.onFormSubmit}>
          <input name="statusId" value={this.state.status} type="hidden" />
          <input
            name="orderId"
            value={
              IsEmpty(this.state.selectedOrder)
                ? 0
                : this.state.selectedOrder.orderId
            }
            type="hidden"
          />
          <input name="remarks" value={this.state.remarks} type="hidden" />
          <input
            type="submit"
            style={{ display: "none" }}
            id="btnStatusSubmit"
          />
        </form>
        <ImageViewDialogV2
          downloadFile={(e, fileName) => this.downloadFile(e, fileName)}
          handleClose={() => this.handleCloseImageDialog()}
          open={this.state.isOpenImageViewer}
          data={this.state}
          onNextArrowClick={() => this.onNextArrowClick()}
          onBackArrowClick={() => this.onBackArrowClick()}
        />

        <ChangeStatusV2
          onSaveClick={() => this.onImagesConfirmationClick(3)}
          onHandleChange={(e) => this.onHandleChange(e)}
          open={this.state.openChangeStatusDialog}
          state={this.state}
          handleClose={() => this.handleChangeStatusClose()}
        />

        <EditTrayV2
          onSaveClick={() => this.onEditTray()}
          onHandleChange={(e) => this.onHandleChange(e)}
          open={this.state.openEditTrayDialog}
          state={this.state}
          handleClose={() => this.handleChangeEditTrayClose()}
        />

        <div style={{ width: "100%", display: "flex", marginTop: 50 }}>
          <Fragment>
            {!IsEmpty(this.state.selectionTabStatus) &&
              this.state.selectionTabStatus.map((status, index) => {
                let latestIndex = index + 1;
                return (
                  <>
                    <BootstrapButton
                      key={index}
                      variant="contained"
                      color="primary"
                      className={`${classes.margin} ${
                        latestIndex === this.state.activeButtonIndex
                          ? classes.activeButton
                          : ""
                      }`}
                      onClick={() => {
                        const { isForceCancel } = this.state;
                        this.setState({
                          activeButtonIndex: latestIndex,
                          filterStatus: latestIndex,
                          isForceCancel: !isForceCancel,
                        });
                        // alert(latestIndex)
                        this.onHandleChange({
                          target: { name: "filterStatus", value: status.value },
                        });
                      }}
                    >
                      {status.name} ({status.count})
                    </BootstrapButton>
                  </>
                );
              })}
          </Fragment>
        </div>

        <div
          style={{
            minHeight: window.innerHeight - 120,
            maxHeight: window.innerHeight - 120,
            overflow: "auto",
          }}
          className={classes.tabsContainer}
        >
          <OrderTabV2
            onHandleChange={this.onHandleChange}
            onFocusOutTrayBarCodeField={this.onFocusOutTrayBarCodeField}
            values={this.state}
            textFieldRef={this.textFieldRef}
            getOrderId={(id) => this.getOrderId(id)}
          />
        </div>
        <div
          style={{ marginBottom: 10 }}
          className={classes.tabsContentContainer}
        >
          {/* <div  className={classes.contentItemsContainerSM}> */}
          <SalesTabV3
            columns={this.state.columns || []}
            rows={this.state.rows || []}
            values={this.state}
            onHandleChange={this.onHandleChange}
            onFocusOutTrayBarCodeField={this.onFocusOutTrayBarCodeField}
            textFieldRef={this.textFieldRef}
            printBarcode={() => this.printBarcode()}
            downloadPdfImagesData={() => this.downloadPdfImagesData()}
            downloadImagesData={() => this.downloadImagesData()}
            toggleEditTrayDialog={() => this.toggleEditTrayDialog()}
            onDownloadComplete={() => this.isDocumentPrintDocumentDownloaded()}
          />
          {/* </div> */}
        </div>

        <div className={classes.tabsContentContainerImages}>
          {!IsEmpty(salesDataObj) && (
            <div className={classes.contentContainerImages}>
              <ImagesTabV2
                values={this.state}
                // downloadPdfImagesData={() => this.downloadPdfImagesData()}
                // downloadImagesData={() => this.downloadImagesData()}
                onImageClick={(object) => this.onImageClick(object)}
                onImagesConfirmationClick={(statusType) =>
                  this.onImagesConfirmationClick(statusType)
                }
                toggleChangeStatusDialog={() => this.toggleChangeStatusDialog()}
                sendToQA={(actionId) => this.sendToQA(actionId)}
              />
            </div>
          )}
        </div>

        <CustomizedSnackbar
          isOpen={this.state.isOpenSnackbar}
          message={this.state.snackbarMessage}
          severity={this.state.snackbarSeverity}
          handleCloseSnackbar={() => this.handleSnackbar(false, "", "")}
          autoHideDuration={3000}
        />
      </Fragment>
    );
  }
}

C08SublimationPrintingDashboard.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(useStyles)(C08SublimationPrintingDashboard);
